/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PresenterFixedAssetFilter, PresenterOneFixedAssetResponse } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class Search<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * @description Get the fixed assets list
   *
   * @tags search
   * @name FixedAssetsCreate
   * @summary Get the fixed assets list
   * @request POST:/search/fixed_assets
   */
  fixedAssetsCreate = (body: PresenterFixedAssetFilter, params: RequestParams = {}) =>
    this.http.request<PresenterOneFixedAssetResponse[], any>({
      path: `/search/fixed_assets`,
      method: 'POST',
      body: body,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
